import { IAddressFields, IFieldsData, ILoggedIn, RootState } from '@checkout/state';
import * as cx from 'classnames';
import { Field, FormikContext, connect as formikConnect } from 'formik';
import * as React from 'react';
import { FocusEvent } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { ICheckoutContextConfig } from './../../../config/contextCheckoutConfig.d';
import { updatePaymentFieldsRequest } from './../../../reducers/checkout';
import * as Styles from './ContactDetailsForm.scss';
import { getContactDetailsFormModel } from './ContactDetailsFormModel';

interface IOwnProps {
  fields: IAddressFields;
  formName: string;
  checkoutContextConfig: ICheckoutContextConfig;
  readOnly?: boolean;
}

interface IConnectedFormikProps {
  formik: FormikContext<IFieldsData>;
}

interface IConnectetDispatchProps {
  updatePaymentFieldsRequest: typeof updatePaymentFieldsRequest;
}

interface IConnectedProps {
  country: string;
  loggedIn: ILoggedIn | null;
}

type Props = IOwnProps & IConnectedProps & IConnectedFormikProps & IConnectetDispatchProps & InjectedIntlProps;

interface IOwnState {
  email: string;
}

class ContactDetailsForm extends React.Component<Props, IOwnState> {

  state: IOwnState = {
    email: this.props.formik.values.contactDetails.email,
  };

  handleEmailBlur = (event: FocusEvent<any>) => {
    const { checkoutContextConfig, formik, updatePaymentFieldsRequest: updatePaymentField } = this.props;
    const isEmailValid = (formik.errors.contactDetails && formik.errors.contactDetails.email) === undefined;
    const email = formik.values.contactDetails.email;

    // Trigger Abandonment Email Centra `/payment-fields` endpoint (Centra is triggering Rulemailer a minute after this request)
    if (checkoutContextConfig.externalServices.cartAbandonmentEmail.enabled && isEmailValid && email !== this.state.email) {
      updatePaymentField({
        address: {
          email
        },
        cartAbandonmentEmail: true,
      });
      this.setState({ email });
    }
  }

  render() {
    const { readOnly, fields, formName, intl, country, checkoutContextConfig, loggedIn } = this.props;
    if (!fields) { return null; }
    const addersFormModel = getContactDetailsFormModel(fields, formName, intl, checkoutContextConfig, loggedIn !== null, this.handleEmailBlur);

    const contactDetailsFieldsClassNames = cx({
      [Styles.fieldset]: true,
      [Styles.addressReadOnly]: readOnly,
    });

    return (
      <div className={contactDetailsFieldsClassNames}>
        {addersFormModel.map((field) => {
          const { visible, name, ...fieldProps } = field;

          return visible && (
            <Field
              {...fieldProps}
              key={`${formName}.${name}`}
              id={`${formName}.${name}`}
              name={`${formName}.${name}`}
              readOnly={readOnly}
              country={country}
            />
          );
        })}
      </div>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      country: state.checkout.location && state.checkout.location.country,
      loggedIn: state.checkout.loggedIn,
    }),
    {
      updatePaymentFieldsRequest
    },
  )
)(formikConnect(ContactDetailsForm));
